module.exports = __webpack_public_path__ + "media/student_lending_center/st_logo-26b7bfd8.png";